export enum ApplicationSetting {
    /* SCOPE Settings */
    SCOPE__AGENCY_HOURS = 'SCOPE__AGENCY_HOURS',
    SCOPE__FIXED_COST_DELIVERABLE_EDITING = 'SCOPE__FIXED_COST_DELIVERABLE_EDITING',
    CURRENCY_CONVERSION = 'CURRENCY_CONVERSION'
}
